import * as React from 'react';
import LoginForm from './LoginForm/Component';
export const Component = props => {
    var _a, _b;
    const login = ((_a = props.initialValues) === null || _a === void 0 ? void 0 : _a.email) || ((_b = props.initialValues) === null || _b === void 0 ? void 0 : _b.phone);
    return React.createElement(LoginForm, { login: login, onSuccess: props.onSuccess });
};
Component.displayName = 'LoginPage';
export default Component;
